import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import MyStorage from './util/storage'
import { Oval as Loader } from 'react-loader-spinner'
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';
import { db1, storage1 } from '../../firebase/firebase1';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import add from '../assets/add.png';
import cross from '../assets/delete.png';
import Resizer from 'react-image-file-resizer';
import Api from './api/api';
import firebase from "firebase/compat/app";

let i = 1
let imageUrls = []

const AdminAddMindArticle = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const model = location.state.model
  const type = location.state.type
  const editMode = model != null

  const [title, setTitle] = useState(editMode ? model.title : '');

  const [loader, setLoader] = useState(false);
  const addScreenshot = useRef(null);
  const [images, setImages] = useState([{}]);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange = (editorState) => {
    console.log(JSON.stringify(editorState));
    setEditorState(editorState)
  };

  useEffect(() => {
    if (editMode) {
      // testing
      // const sampleMarkup =
      //   '<b>Bold text</b>, <i>Italic text</i><br/ ><br />' +
      //   '<a href="http://www.facebook.com">Example link</a>';

      const contentBlock = htmlToDraft(model.body);
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      setEditorState(EditorState.createWithContent(contentState))

      // const blocksFromHTML = convertFromHTML(model.body);
      // const state = ContentState.createFromBlockArray(
      //   blocksFromHTML.contentBlocks,
      //   blocksFromHTML.entityMap,
      // );
      // setEditorState(EditorState.createWithContent(state))

      let images = [{}];
      for (let i = 0; i < model.images.length; i++) {
        images = images.concat({
          file: null,
          url: model.images[i],
          name: '',
        })
        if (i === model.images.length - 1)
          setImages(images);
      }
    }
  }, [])

  if (!MyStorage.isLogin()) {
    console.log('not logged in');
    navigate('/login')
    return null
  }

  const addNewArticle = () => {
    if (title == '') {
      showToast('error', 'Fill complete form!')
      return
    }

    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    console.log('body: ' + body);
    if (body.length < 10) {
      showToast('error', 'Please enter body!')
      return
    }

    setLoader(true);
    uploader(title, body)
  };

  const editNewModel = () => {
    if (title == '') {
      showToast('error', 'Fill complete form!')
      return
    }

    let body = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    console.log('body: ' + body);
    if (body.length < 10) {
      showToast('error', 'Please enter body!')
      return
    }

    setLoader(true);
    // update images
    i = 1
    imageUrls = []
    updater()

    // update info
    db1.collection(type + '_articles')
      .doc(model.id)
      .set({
        title: title,
        body: body
      }, { merge: true })
      .then(() => {
        setLoader(false);
        showToast('success', 'Article Saved!')
        navigate(-1)
      })
      .catch(error => {
        showToast('error', 'Save Failed!');
      });
  };

  const uploader = (title_, body_) => {
    if (images.length == 1) {
      addArticleToFirebase(title_, body_, [])
      return
    }
    const image = images[i];
    uploadPhoto(
      'articles/' + image.file.name,
      image.file,
      (imageUrl) => {
        console.log('imageUrl: ' + imageUrl);
        imageUrls.push(imageUrl)
        console.log('image added');
        if (i === images.length - 1) {
          addArticleToFirebase(title_, body_, imageUrls)
        }
        else {
          console.log('next upload');
          i++
          uploader(title_, body_)
        }
      }
    );
  };

  const addArticleToFirebase = (title, body, urls) => {
    console.log('add article');
    let article = {
      title: title,
      body: body,
      images: urls,
      added_date: parseInt(moment() + '')
    };
    console.log(JSON.stringify(article));
    db1.collection(type + '_articles')
      .add(article)
      .then((doc) => {
        setLoader(false);
        showToast('success', 'Article Saved!')
        sendNotification(doc.id)
        navigate(-1)
      })
      .catch(error => {
        showToast('error', 'Save Failed!');
      });
  };

  const sendNotification = (docId) => {
    let title = 'New Article by Liviq'
    let body = 'Do not miss this important article by Liviq!'
    // add to database
    let obj = {
      title: title,
      body: body,
      type: type, // exercise, mind
      docId: docId, // video, exercise, mind
      added_date: firebase.firestore.FieldValue.serverTimestamp()
    }
    db1.collection('notifications').add(obj)
    Api.sendPushToAll(title, body,
      () => {
        //
      },
      () => {
        //
      })
  };

  const updater = () => {
    if (images.length == 1) {
      return
    }
    const image = images[i];
    if (image.file == null) {
      console.log('already uploaded');
      imageUrls.push(image.url)
      if (i === images.length - 1) {
        updateArticleImageUrls()
      }
      else {
        console.log('next upload');
        i++
        updater()
      }
      return
    }
    uploadPhoto(
      'articles/' + image.file.name,
      image.file,
      (imageUrl) => {
        console.log('imageUrl: ' + imageUrl);
        imageUrls.push(imageUrl)
        console.log('image added');
        if (i === images.length - 1) {
          console.log('update article');
          updateArticleImageUrls()
        }
        else {
          console.log('next upload');
          i++
          updater()
        }
      }
    );
  };

  const updateArticleImageUrls = () => {
    console.log('imageUrls: ' + imageUrls.length);
    db1.collection(type + '_articles')
      .doc(model.id)
      .set({
        images: imageUrls
      }, { merge: true })
  };

  const uploadPhoto = (path, photo, onSuccess) => {
    const uploadTask = storage1.ref(path).put(photo);
    uploadTask.on('state_changed',
      (snapshot) => {
        // const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      },
      (error) => {
        console.log(error);
      },
      () => {
        storage1.ref(path).getDownloadURL().then((url) => {
          onSuccess(url);
        })
      });
  };

  const resizeFile = (file) => new Promise(resolve => {
      Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 90, 0,
          uri => {
              resolve(uri);
          }, 'file');
  });

  const handleAddImage = async (event) => {
    let temp = [{}];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const resizedImage = await resizeFile(file);
      let url = URL.createObjectURL(resizedImage);
      temp = temp.concat({ file: resizedImage, url: url, name: resizedImage.name });
    }
    setImages(temp);
  };

  const showProductImages = () => {
    return images.map((item, index) => {
      if (index == 0) {
        return (
          <div style={{ marginRight: 10, marginBottom: 10 }}>
            <div onClick={() => {
              // browse screenshot
              addScreenshot.current.click();
            }} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={add} style={{ width: 30, height: 30 }} />
              <input
                multiple
                type='file'
                style={{ display: 'none' }}
                ref={addScreenshot}
                onChange={handleAddImage}
              />
            </div>
          </div>
        );
      }
      return (
        <div style={{ display: 'inline-flex', width: 100, height: 100, marginRight: 10, marginBottom: 10 }}>
          <img src={item.url} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
          <div onClick={() => {
            // delete screenshot
            const temp = images.filter((item, j) => {
              return index !== j; //false will delete
            });
            setImages(temp);
          }} style={{ width: 25, height: 25, marginLeft: -25, marginTop: 0, backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={cross} style={{ width: 20, height: 20 }} />
          </div>
        </div>
      );
    });
  }

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>
          Add Article
        </div>
      </div>

      <div
        style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
          <Form className='form' style={{ padding: 20, backgroundColor: 'white', borderRadius: 10, minWidth: 600 }}>

            <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center' }}>

              <FormGroup style={{ marginTop: 0, width: '100%' }}>
                <Input
                  style={{ fontSize: 18 }}
                  type='text'
                  placeholder='Enter Title'
                  value={title}
                  onChange={(event) => {
                    console.log('change: ' + event.target.value);
                    setTitle(event.target.value)
                  }} />
              </FormGroup>
              <FormGroup style={{ marginTop: 10, width: '100%' }}>
                <div>Description</div>
                <Editor
                  editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 150 }}
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}
                />
                {/* <Input
                  style={{ fontSize: 18 }}
                  type='text'
                  placeholder='Enter Description...'
                  value={detail}
                  onChange={(event) => {
                    console.log('change: ' + event.target.value);
                    setDetail(event.target.value)
                  }} /> */}
              </FormGroup>

              <FormGroup style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                <div>Images:</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                  {showProductImages()}
                </div>
              </FormGroup>

            </div>

            <Button
              className='btn-block btn-dark'
              style={{ marginTop: 15, fontSize: 16, width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
              onClick={() => {
                if (!editMode)
                  addNewArticle()
                else
                  editNewModel()
              }}>
              Save Article
            </Button>

          </Form>
        </div>
      </div>

      {loader ?
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <div style={{ padding: 10, backgroundColor: 'red', borderRadius: 100 }}>
            <Loader
              type="ThreeDots"
              color="white"
              height={70}
              width={70}
              visible={true} />
          </div>
        </div>
        :
        null
      }

      <div>
        <ToastContainer />
      </div>

    </div>
  );
}

export default AdminAddMindArticle;